<template>
  <div class="upload_k">
    <!--
    'https://onebitsivan.oss-cn-beijing.aliyuncs.com/'+
    -->
    <div class="upload_block" v-for="item,index in images_arr">
      <div class="deletefile" v-on:click="del_images(index)">X</div>
      <img :src="item" width="100%" v-on:click="openbig(item)" class="deletefile_img">
    </div>
    <div class="upload_block" v-if="uploadok">

      <div id="Loading" v-html="videomsg">

      </div>
      <input :id="ffname" type="file" class="upload_input" v-on:click="kong" v-on:change="uploadfile()" ref="referenceUpload" >
    </div>
  </div>
</template>

<script>

export default {
  props: ['upload_num', 'jsonimgstr',],  //接受父组建传递的值 1 上传数量 2 图片地址
  data() {
    return {
      images_arr: [],
      uploadok: true,
      videomsg: "+",


      ffname: this.ffname,
    }
  },
  watch: {
    jsonimgstr: function (val, oldval) {
      //console.log('new-jsonimgstr:'+val+'------old--jsonimgstr:'+oldval);
      this.images_arr = JSON.parse(this.jsonimgstr);
    },
    images_arr: function (val, oldval) {
      //console.log('new:'+val+'------old:'+oldval);
      if (this.images_arr.length >= this.upload_num) {
        this.uploadok = false;
      } else {
        this.uploadok = true;
      }
    }
  },
  created() {
    this.ffname = Math.random();
    // console.log(Math.random());
  },
  methods: {
    uploadfile: function () {
      let x = document.getElementById(this.ffname).files[0];
      console.log(x);
      let params = new FormData(); //创建一个form对象
      params.append('uploadimgfilename', x, x.name);  //append 向form表单添加数据
      this.videomsg = '<div class="loader-inner ball-beat"><div></div> <div></div> <div></div></div>';
      console.log('start uploading' + Math.random());
      this.$axios({
        method: 'post',
        url: '/api/wenda/uploadimg',
        data: params,
        //async:true,
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(function OnSuccess(response) {
        //console.log('ready uploading')
        if (response.status == 200) {

          if (response.data.code == 1) {
            //false
            alert(response.data.msg);
            this.videomsg = '+'
          } else if (response.data.code == 0) {
            //success
            this.videomsg = '+';
            this.images_arr.push(response.data.url);
            this.$emit('getstrfunc', JSON.stringify(this.images_arr));
            this.$refs.referenceUpload.value = null;


          }

          //console.log('uploading ok')


        } else {
          console.log('uploading...')
        }

      }.bind(this)).catch(function OnError(response) {
        console.log('传输异常')
        console.log(response)
      })


    },
    del_images: function (i) {
      this.images_arr.splice(i, 1);
      this.$emit('getstrfunc', JSON.stringify(this.images_arr));
    },
    kong: function () {
      this.yy = Math.random();
    },
    openbig: function (url) {
      swal({
        title: '',
        text: '',
        imageUrl: url,
        imageWidth: '100%',
        animation: false
      })
    }


  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.upload_k {
  width: 100%;
  padding-bottom: 10px;
  float: left;
  margin-right: 5px;

}

.upload_block {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  margin-right: 3px;
  text-align: center;
  line-height: 100px;
  overflow: hidden;
  float: left;

}

.upload_input {
  width: 100px;
  height: 100px;
  opacity: 0;
  top: -100px;
  position: relative;
  z-index: 199;
}


#Loading {
  top: 50%;
  left: 50%;
  position: relative;
  -webkit-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
  z-index: 1;
}

@-webkit-keyframes ball-beat {
  50% {
    opacity: 0.2;
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes ball-beat {
  50% {
    opacity: 0.2;
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.ball-beat > div {
  background-color: #279fcf;
  width: 15px;
  height: 15px;
  border-radius: 100% !important;
  margin: 2px;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: inline-block;
  -webkit-animation: ball-beat 0.7s 0s infinite linear;
  animation: ball-beat 0.7s 0s infinite linear;
}

.ball-beat > div:nth-child(2n-1) {
  -webkit-animation-delay: 0.35s !important;
  animation-delay: 0.35s !important;
}

.deletefile {
  width: 15px;
  height: 15px;
  top: 0px;
  position: relative;
  line-height: 0;
  right: 0px;
  z-index: 99;
  margin-top: 10px;
}

.deletefile_img {
  top: -25px;
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile_more.vue